'use client'
import { tw } from 'utils/classnames'
import { useTranslations } from 'next-intl'
import { ChevronRightIcon } from 'primitives/icons'

import { useCategoriesDataContext, useCollapseAll, useExpandAll } from './context'

export function ExpandAll({ className }: { className?: string }) {
  const t = useTranslations('prod.product_description_page.explore')
  const { open, categories } = useCategoriesDataContext()
  const isAnyOpen = open.length !== 0
  const isAnyClosed = open.length !== categories.length
  const expandAll = useExpandAll()
  const collapseAll = useCollapseAll()
  const text = isAnyOpen ? t('collapse_all') : t('expand_all')

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        className={tw(
          'bg-cf-white rounded-2 hover:shadow-cf-elevation-light-1 grow-0 border border-[#E2D9F2]',
          'mt-8 flex items-center justify-center gap-2 p-2 px-4',
          className,
        )}
        onClick={() => {
          if (isAnyOpen) {
            collapseAll()
          }
          if (isAnyClosed) {
            expandAll()
          }
        }}
      >
        <ChevronRightIcon
          className={tw('w-4 rotate-90 transform transition-all', isAnyOpen && '-rotate-90')}
        />
        <span>{text}</span>
      </button>
    </div>
  )
}
